/* LA TRIBUNA — Global JS v3.0
   Slider, countdown, urgency counter, scroll animations, rev bars */
(function() {
  'use strict';

  /* ── Scroll fade-in ── */
  function initFadeUp() {
    var els = document.querySelectorAll('.lt-fade-up');
    if (!els.length) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('lt-vis');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    els.forEach(function(el) { obs.observe(el); });
  }

  /* ── Review bars animation ── */
  function initRevBars() {
    var bars = document.querySelectorAll('.lt-bar-fill');
    if (!bars.length) return;
    var done = false;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting && !done) {
          done = true;
          bars.forEach(function(b) {
            var w = b.getAttribute('data-w') || b.style.width;
            b.style.width = '0';
            setTimeout(function() { b.style.width = w; }, 100);
          });
          obs.disconnect();
        }
      });
    }, { threshold: 0.2 });
    var sec = document.querySelector('.lt-reviews');
    if (sec) obs.observe(sec);
  }

  /* ── Countdown (resets daily at midnight) ── */
  function initCountdown() {
    var h = document.getElementById('lt-cd-h');
    var m = document.getElementById('lt-cd-m');
    var s = document.getElementById('lt-cd-s');
    if (!h || !m || !s) return;
    function flip(el, val) {
      if (el.textContent !== val) {
        el.classList.add('lt-flip');
        setTimeout(function() { el.textContent = val; el.classList.remove('lt-flip'); }, 150);
      }
    }
    function tick() {
      var now = new Date(), end = new Date(now);
      end.setHours(23, 59, 59, 0);
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      flip(h, String(Math.floor(diff / 3600)).padStart(2, '0'));
      flip(m, String(Math.floor((diff % 3600) / 60)).padStart(2, '0'));
      flip(s, String(diff % 60).padStart(2, '0'));
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── Urgency viewer counter ── */
  function initUrgency() {
    var el = document.getElementById('lt-urgency-count');
    if (!el) return;
    var base = Math.floor(Math.random() * 8) + 7;
    el.textContent = base;
    setInterval(function() {
      var delta = Math.random() > 0.5 ? 1 : -1;
      base = Math.max(4, Math.min(22, base + delta));
      el.textContent = base;
    }, Math.floor(Math.random() * 8000) + 4000);
  }

  /* ── Hero Slider ── */
  function initSlider() {
    var slides = document.querySelectorAll('.lt-slide');
    var dots   = document.querySelectorAll('.lt-s-dot');
    if (!slides.length) return;
    var cur = 0, total = slides.length, timer;

    function goSlide(n) {
      slides[cur].classList.remove('lt-active');
      if (dots[cur]) dots[cur].classList.remove('lt-active');
      cur = ((n % total) + total) % total;
      slides[cur].classList.add('lt-active');
      if (dots[cur]) dots[cur].classList.add('lt-active');
      clearInterval(timer);
      timer = setInterval(nextSlide, 5500);
    }
    function nextSlide() { goSlide(cur + 1); }
    function prevSlide() { goSlide(cur - 1); }

    dots.forEach(function(d, i) { d.addEventListener('click', function() { goSlide(i); }); });
    var btnPrev = document.querySelector('.lt-s-arrow-prev');
    var btnNext = document.querySelector('.lt-s-arrow-next');
    if (btnPrev) btnPrev.addEventListener('click', prevSlide);
    if (btnNext) btnNext.addEventListener('click', nextSlide);

    // Touch/swipe support
    var startX = 0;
    var sliderWrap = document.querySelector('.lt-slider-wrap');
    if (sliderWrap) {
      sliderWrap.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
      sliderWrap.addEventListener('touchend', function(e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) { diff > 0 ? nextSlide() : prevSlide(); }
      }, { passive: true });
    }

    timer = setInterval(nextSlide, 5500);
  }

  /* ── Sticky header scroll class ── */
  function initStickyHeader() {
    var hdr = document.getElementById('lt-site-header') || document.querySelector('header');
    if (!hdr) return;
    window.addEventListener('scroll', function() {
      hdr.classList.toggle('lt-scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  /* ── Init all ── */
  function init() {
    initFadeUp();
    initRevBars();
    initCountdown();
    initUrgency();
    initSlider();
    initStickyHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
